module.exports = __webpack_public_path__ + "f9f22e87492f01e6fd97b0854efc0985.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/piano-button.png
// module id = 48
// module chunks = 0